import React from 'react';

interface AgentStat { name: string; runs: number; success: number; }
interface Payload { agents?: AgentStat[]; total_runs?: number; }

export default function AgentRunsStatus({ data }: { data: unknown }) {
  const d = (data ?? {}) as Payload;
  const agents = d.agents ?? [];
  const wrapSt:  React.CSSProperties = { height: '100%', display: 'flex', flexDirection: 'column' };
  const labelSt: React.CSSProperties = { fontSize: 12, color: 'var(--tg-theme-hint-color)', margin: 0 };
  const numSt:   React.CSSProperties = { fontSize: 24, fontWeight: 700, margin: '4px 0', color: 'var(--tg-theme-accent-text-color)' };
  const subSt:   React.CSSProperties = { fontSize: 10, color: 'var(--tg-theme-hint-color)', marginLeft: 6 };
  const listSt:  React.CSSProperties = { flex: 1, overflowY: 'auto', listStyle: 'none', margin: 0, padding: 0, marginTop: 4 };
  const rowSt:   React.CSSProperties = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 };
  const nameSt:  React.CSSProperties = { fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '60%', opacity: 0.85 };
  const statSt:  React.CSSProperties = { fontSize: 11, color: 'var(--tg-theme-hint-color)' };
  const emptySt: React.CSSProperties = { fontSize: 12, color: 'var(--tg-theme-hint-color)' };
  return (
    <div style={wrapSt}>
      <p style={labelSt}>Агенты</p>
      {d.total_runs != null && (
        <p style={numSt}>
          {d.total_runs}
          <span style={subSt}>зап.всего</span>
        </p>
      )}
      <ul style={listSt}>
        {agents.slice(0, 4).map((a) => (
          <li key={a.name} style={rowSt}>
            <span style={nameSt}>{a.name}</span>
            <span style={statSt}>{a.runs} / {a.success} ✓</span>
          </li>
        ))}
        {agents.length === 0 && <li style={emptySt}>Нет данных</li>}
      </ul>
    </div>
  );
}
